import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import LanguageSelector from '../components/LanguageSelector';
import useTranslation from '../data/useTranslation';

function NotFound() {
  const { t } = useTranslation();
  const n = t.notFound;

  return (
    <div className="min-h-screen bg-[#111827] text-white flex flex-col" data-testid="notfound-page">
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#111827]/95 backdrop-blur-md border-b border-gray-800">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl font-bold text-orange-500">BPM</span>
            <span className="hidden sm:inline text-sm text-gray-500">Beyond Personal Matrix</span>
          </Link>
          <LanguageSelector />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-lg text-center">
          <p className="text-8xl sm:text-9xl font-bold text-orange-500/80 mb-4" data-testid="notfound-code">404</p>
          <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-white" data-testid="notfound-title">{n.title}</h1>
          <p className="text-gray-400 text-lg mb-8" data-testid="notfound-body">{n.body}</p>
          <Link
            to="/"
            data-testid="notfound-cta"
            className="inline-flex items-center gap-2 px-8 py-4 bg-orange-500 hover:bg-orange-600 rounded-xl font-bold text-lg transition-all shadow-lg shadow-orange-500/30"
          >
            <Home className="w-5 h-5" />
            {n.cta}
          </Link>
        </div>
      </main>

      <footer className="py-8 border-t border-gray-800">
        <div className="container mx-auto px-6 text-center text-sm text-gray-600">
          {t.landing.copyright}
        </div>
      </footer>
    </div>
  );
}

export default NotFound;
